import Http from "./http";

export const updateNotificationsAPI = (data) => {
    return Http.post("admin/updateNotification", data);
};
